import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Variant = 'tier-1' | 'tier-2' | 'tier-3' | 'score-high' | 'score-mid' | 'score-low' | 'neutral';

type TagProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: Variant;
};

const variantStyles: Record<Variant, string> = {
  'tier-1': 'border-accent text-accent',
  'tier-2': 'border-accent-warn text-accent-warn',
  'tier-3': 'border-muted text-muted',
  'score-high': 'border-score-high text-score-high',
  'score-mid': 'border-score-mid text-score-mid',
  'score-low': 'border-score-low text-score-low',
  neutral: 'border-border text-muted',
};

export function Tag({ variant = 'neutral', className, children, ...props }: TagProps) {
  return (
    <span
      className={cn(
        'inline-block font-(family-name:--font-ui) text-[0.65rem] font-medium uppercase tracking-[0.12em]',
        'px-2 py-0.5 rounded-(--radius-sm) border bg-surface-elevated',
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
